"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./turing-footer.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TuringFooter = function TuringFooter(props) {
  var currentYear = new Date().getFullYear();
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "footer",
    style: {
      backgroundColor: props.backgroundColor
    },
    className: "footerContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "CopyWrites",
    key: "FooterCopyWrites"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "TuringTitle"
  }, "Turing"), /*#__PURE__*/_react["default"].createElement("span", null, "\xA9", currentYear)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "menu",
    key: "FooterMenu"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Terms of Service"), /*#__PURE__*/_react["default"].createElement("span", null, "Privacy Policy")));
};
var _default = exports["default"] = TuringFooter;